import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-blue-icons',
	templateUrl: './blue-icons.component.html',
	styleUrls: ['./blue-icons.component.scss'],
})
export class BlueIconsComponent implements OnInit {
	@Input() blueIcon: BlueIconType;
	constructor() {
	}

	ngOnInit(): void {
	}
}

export type BlueIconType =
	| 'blue-briefcase'
	| 'blue-phone-out'
	| 'percentage-receipt'
	| 'blue-tags'
	| 'overdraft-rich-icon'
	| 'stopwatch'
	| 'standalone-briefcase-sm'
	| 'blue-deposit-sm'
	| 'blue-withdrawal-sm'
	| 'blue-open-vault'
	| 'blue-piggy'
	| 'repeat'
	| 'download'
	| 'share'
	| 'eye'
	| 'blue-caret-down'
	| 'bank'
	| 'funds-transfer'
	| 'transfers'
	| 'blue-location-pin'
	| 'blue-id-card'
	| 'blue-some'
	| 'settings'
	| 'blue-pos-purchase'
	| 'blue-pos-withdrawal-pin'
	| 'blue-pos-receipt-config'
	| 'blue-pos-ownership-status'
	| 'blue-pos'
	| 'blue-info'
	| 'blue-edit'
	| 'blue-caret-right'
	| 'blue-circle-right-arrow'
	| 'blue-caret-down-lg'
	| 'blue-brief-case-sm'
	| 'blue-avatar'
	| 'blue-avatar-inverted'
	| 'blue-download-sm'
	| 'blue-card'
	| 'blue-earnings'
	| 'blue-packet'
	| 'blue-carton'
	| 'blue-envelope'
	| 'blue-download-lg'
	| 'blue-transfer'
	| 'blue-new-transfer'
	| 'blue-caret-down-xs'
	| 'blue-download'
	| 'blue-phone-sm'
	| 'blue-wireless-sm'
	| 'blue-fund-transfer-xs'
	| 'blue-white-fund-transfer-xs'
	| 'blue-notification-info'
	| 'blue-notification-error'
	| 'blue-notification-warning'
	| 'blue-retry'
	| 'blue-agriculture'
	| 'blue-filter'
	| 'blue-filter-lines'
	| 'blue-terminal-pin'
	| 'blue-security'
	| 'blue-device'
	| 'blue-limits'
	| 'blue-certificate'
	| 'blue-plain-certificate'
	| 'blue-book-keeping'
	| 'blue-language'
	| 'blue-business'
	| 'blue-loader-icon'
	| 'blue-reciept-config'
	| 'blue-reset-pin'
	| 'blue-circle-eye'
	| 'blue-plain-avatar'
	| 'blue-download-v2'
	| 'blue-eod-icon'
	| 'blue-self-test-icon'
	| 'blue-business-user-icon'
	| 'blue-plus-icon'
	| 'blue-id-and-business-card-icon'
	| 'blue-downloadable-material-icon'
	| 'blue-notification'
	| 'admin-role-icon'
	| 'accountant-role-icon'
	| 'auditor-role-icon'
	| 'cashier-role-icon'
	| 'default-role-icon'
	| 'blue-double-arrows'
	| 'blue-account'
	| 'blue-thumbs-up'
	| 'blue-business-details'
	| 'erp-integration'
	| 'ussd'
	| 'users'
	| 'upload'
	| 'world'
	| 'grey-transaction'
	| 'blue-dropdown'
	| 'blue-boolean'
	| 'blue-text'
	| 'blue-number'
	| 'blue-developer-option'
	| 'blue-web-hook'
	| 'blue-key'
	| 'blue-moniepoint-logo'
	| 'blue-arrow-bar-right'
	| 'blue-consent-icon'
